import { Loader } from '@googlemaps/js-api-loader';

export default class googleMaps{

    /**
     * Init map
     * @param el 
     */
    initMap(elFrames: string = '.location-map', elMarker: string = '.marker'){

        const _that = this;

        // Get Frames
        const frames = document.querySelectorAll(elFrames);

        if(frames.length === 0){
                
            return;

        }

        frames.forEach((frame) => {

            // Frame ID
            const frame_id: string = frame.id;

            // Frame element ID
            const frame_el_id = document.getElementById(frame_id) as HTMLElement;

            // Frame zoom
            const get_frame_zoom = frame.getAttribute('data-zoom');

            let frame_zoom = 16;

            if(get_frame_zoom !== null){
                
                frame_zoom = parseInt(get_frame_zoom);

            }

            // Map options
            const mapOptions = {
                zoom: frame_zoom,
                mapId: '6dd54760e1f8c8e3'
            };

            // Get markers
            const class_markers = frame.querySelectorAll(elMarker);

            if(class_markers.length === 0){
                
                return;

            }

            // Init Loader
            const loader = new Loader({
                apiKey: process.env.KEY_GOOGLE_MAPS ?? '',
                version: "weekly"
            });

            loader
            .importLibrary('maps')
            .then(async ({ Map }) => {

                // Init map
                const map = new Map(frame_el_id, mapOptions);

                // Import library
                const { AdvancedMarkerElement } = await loader.importLibrary('marker');
                const { InfoWindow } = await loader.importLibrary('streetView');
                const { LatLngBounds, event } = await loader.importLibrary('core');

                // Create map boundaries from all map markers.
                const bounds = new LatLngBounds();

                // Init markers
                const markers: any = [];

                // Foreach markers
                class_markers.forEach(function(marker){
                    
                    const eltmarker = marker as HTMLElement;
            
                    const info_marker = _that.initMarker(
                        frame,
                        map,
                        eltmarker,
                        AdvancedMarkerElement,
                        InfoWindow,
                        event
                    );

                    // Append to reference for later use.
                    if(info_marker !== null){
                        
                        markers.push(info_marker);

                    }

                });

                if(markers.length !== 0){
                    
                    _that.centerMap(map, markers, bounds);

                }

            })
            .catch((e) => {
                
                if (!(e instanceof Error)) {
                    e = new Error(e);
                }

                console.error(e.message);

            });
            
        });

    }

    /**
     * Init marker
     * @param frame 
     * @param map 
     * @param AdvancedMarkerElement 
     * @param markers 
     * @param InfoWindow 
     * @param event 
     * @param elMarker 
     */
    protected initMarker(
        frame: Element,
        map: google.maps.Map,
        elMarker: HTMLElement,
        AdvancedMarkerElement: typeof google.maps.marker.AdvancedMarkerElement,
        InfoWindow: typeof google.maps.InfoWindow,
        event: typeof google.maps.event,
    ){

        // Get position from marker.
        const lat = elMarker.getAttribute('data-lat');
        const lng = elMarker.getAttribute('data-lng');
        const icon = elMarker.getAttribute('data-marker');
        let beachFlagImg: HTMLImageElement | null = null;
        let latLng: any = {};

        if(lat !== null && lng !== null){
            
            latLng = {
                'lat': parseFloat(lat),
                'lng': parseFloat(lng)
            };

            let marker_element: any = {
                position : latLng,
                map: map
            };

            if(typeof icon === "string" && icon.length !== 0){
                
                beachFlagImg = document.createElement('img');
                beachFlagImg.src = icon;

                marker_element = {
                    position : latLng,
                    map: map,
                    content: beachFlagImg,
                }

            }
            
            // Create marker instance.
            const marker = new AdvancedMarkerElement(marker_element);

            // Get iframe title
            const title_iframe = elMarker.getAttribute('data-title');

            // If marker contains HTML, add it to an infoWindow.
            if(elMarker.innerHTML.trim().length !== 0){
                
                const marker_hide = elMarker.querySelector('.marker-hide');
                marker_hide?.classList.remove('hidden');
                
                // Create info window.
                const infowindow = new InfoWindow({
                    content: elMarker.innerHTML.trim()
                });

                event.addListenerOnce(map, 'idle', () => {

                    if(title_iframe !== null){
                        
                        frame.getElementsByTagName('iframe')[0].title = title_iframe;

                    }

                })

                // Show info window when marker is clicked.
                event.addListener(marker, 'click', function(){
                    
                    infowindow.open(map, marker);
                    
                });

            }

            return {
                'lat': parseFloat(lat),
                'lng': parseFloat(lng)
            };
            
        }

        return null;

    }

    /**
     * Centers the map showing all markers in view.
     * @param map 
     * @param markers 
     * @param bounds 
     */
    protected centerMap(map: google.maps.Map, markers: any, bounds: google.maps.LatLngBounds){

        markers.forEach(function(marker){
            
            bounds.extend({
                lat: marker.lat,
                lng: marker.lng
            });

        });

        // Case: Single marker.
        if(markers.length == 1){
            
            map.setCenter(bounds.getCenter());

        // Case: Multiple markers.
        }else{
            
            map.fitBounds(bounds);
            
        }

    }
    
}